<template>
	<div style="width: 100vw;" :style="{minHeight:`calc(100vh - ${placeNavHeight}px)`  }">
		<van-overlay :show="loading" style="background-color: rgb(0 0 0 / 0%);">
			<div style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;">
				<van-loading color="#7d7d7d" type="spinner" />
			</div>
		</van-overlay>
		<div 
			style="background-color: #fff;margin: auto;display: flex;flex-direction: column;align-items: center;"
			:style="equipment == 'pc'?{
		 		// width:equipment == 'pc'?'1280px':'100%'
		 		...boxStyleOne,
				minHeight:`calc(100vh - ${placeNavHeight}px)` 
		 	}:{
		 		width:'96%',
				minHeight:`calc(100vh - ${placeNavHeight}px)` 
		 	}">
			<div style="height: 200px;width: 1px;"></div>
			<div style="text-align: center;font-weight: bold;font-size: 26px;">{{$t('h.search')}}</div>
			<div style="height: 30px;width: 1px;"></div>
			<div style="display: flex;align-items: center;width: 100%;">
				<el-input @click="searchGoods" v-model="searchValue" style="width: 50%;margin-left: 20px;" :placeholder="$t('h.search')">
				</el-input>
				<el-select :placeholder="$t('h.selectClassfiy')" style="width: 50%;margin-left: 20px;margin-right: 20px;" class="custom-select"
					@change="changePageCategories" v-model="value">
					<el-option v-for="item in list" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</div>
			<div style="height: 30px;width: 1px;"></div>
			<el-button
				@click="searchGoods"
				style="background-color: black;color: #fff;width: calc(100% - 40px);border: solid 1px #000000 ;">{{$t('h.search')}}</el-button>
		</div>
	</div>
</template>

<script>
	import {
		getSearchCategory
	} from '../../../api/all.js'
	export default {
		props: {
			
			footerHeight: {
				type: Number,
				default: 0
			},
			placeNavHeight: {
				type: Number,
				default: 0
			},
			equipment: {
				type: String,
				default: "pc"
			},
			boxStyleTwo: {
				type: Object,
				default: () => {
					return {}
				}
			},
			boxStyleOne: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				value: "",
				list: [],
				searchValue: "",
				loading: false
			}
		},
		mounted() {
			this.getData()
		},
		methods: {
			changePageCategories() {

			},
			async getData() {
				try {
					this.loading = true
					const data = await getSearchCategory()
					console.log('getDatadata', data)
					this.list = data.data.data
					this.loading = false
					this.$forceUpdate()
				} catch (e) {
					this.loading = false
				}
			},
			searchGoods() {
				this.$router.push({
					path: '/products_search/search?keyword=' + this.searchValue + '&category_id=' + this.value
				})
			}
		}
	}
</script>

<style scoped>
	/deep/ .el-input__inner:focus {
		border: solid 1px #000000;
	}

	/deep/ .el-select .el-input.is-focus .el-input__inner {
		border: 1px solid #000000;
	}

	/deep/ .el-select .el-input__inner:focus {
		border: 1px solid #000000;
	}
</style>